import { Component } from '@angular/core';
import { COPYRIGHTS } from 'app/helpers/constants';

@Component({
    selector: 'recover-footer',
    standalone: true,
    imports: [],
    templateUrl: './recover-footer.component.html',
})
export class RecoverFooterComponent {
    copyrights = COPYRIGHTS;
}
